export default function removeUTMandGCLID() {
  // Get the current URL
  const currentUrl = window.location.href;

  // Check if the URL contains UTM parameters or GCLID parameter
  if (currentUrl.indexOf('utm_') !== -1 || currentUrl.indexOf('gclid=') !== -1) {
    // Split the URL into the base URL and query string
    const baseUrl = currentUrl.split('?')[0];
    const queryString = currentUrl.split('?')[1];

    // Split the query string into individual parameters
    const queryParams = queryString.split('&');

    // Create a new array of parameters that excludes UTM and GCLID parameters
    const cleanParams = queryParams.filter(param => !param.startsWith('utm_') && !param.startsWith('gclid='));

    // Join the clean parameters back into a query string
    const cleanQueryString = cleanParams.join('&');

    // Combine the base URL and clean query string back into a clean URL
    const cleanUrl = baseUrl + (cleanQueryString ? `?${cleanQueryString}` : '');

    // Redirect to the clean URL
    window.history.replaceState({}, document.title, cleanUrl);
  }
}
